import appConstants from '../../../../appConstants';
import { ALPHA_NUMERIC_REGEX } from '../../Dispatch/RouteExecution/constRegex';

const SEARCH_TYPE = {
  PickupNumber: 'pickupNumber',
  ProNumber: 'proId',
  DriverNumber: 'driverNumber'
};

const SEARCH_FILTER_OPTIONS = [
  {
    label: 'Pickup Number',
    value: SEARCH_TYPE.PickupNumber
  },
  {
    label: 'Pro Number',
    value: SEARCH_TYPE.ProNumber
  },
  {
    label: 'Driver Number',
    value: SEARCH_TYPE.DriverNumber
  }
];

const ACTIVE_DETAILS = { STOP: 'STOP', ROUTE_COMPLIANCE: 'ROUTE_COMPLIANCE' };

const NO_FREIGHT = 'NF';

const SEARCH_INPUT_NUMBER_VALIDATION = {
  maxLength: 50, // in DB we have 50 characters for pickup number
  pattern: ALPHA_NUMERIC_REGEX
};
const SEARCH_INPUT_ALPHA_NUMERIC_VALIDATION = {
  maxLength: 12
};
const STOP_MAP_ZOOM = 17;

const DROP_TYPE = {
  CustomerDelivery: 'CUSTOMER DELIVERY',
  AgentInterline: 'AGENT OR INTERLINE',
  TemporaryLocation: 'TEMPORARY LOCATION',
  EmptyTrailer: 'EMPTY TRAILER'
};

const STOP_TYPE = {
  ...appConstants.STOP_TYPE,
  TrailerDrop:"TrailerDrop"
};

const DISPATCH_STATUS = {
  Created: 'Created',
  Started: 'Started'
};
export {
  SEARCH_TYPE,
  SEARCH_FILTER_OPTIONS,
  ACTIVE_DETAILS,
  NO_FREIGHT,
  SEARCH_INPUT_NUMBER_VALIDATION,
  SEARCH_INPUT_ALPHA_NUMERIC_VALIDATION,
  DROP_TYPE,
  STOP_MAP_ZOOM,
  STOP_TYPE,
  DISPATCH_STATUS
};
